module.exports = __webpack_public_path__ + "img/encerradosActive.ab2469e3.svg";